import delay from '../../utils/delay'

import {
  InitializeFormatsetForm,
  InitializeCreativeForm,
  IBlueprintService,
  GetCreativeGuidelines,
} from '../../interfaces/services/blueprints'
import { resultSuccess } from '../../interfaces/base'
import {
  FormChangeHandler,
  formValidation,
  emptyFormGuidelines,
} from '../../interfaces/components/dynamic-form'

import { MultifileCreative as mockedCreativeBlueprint } from '../../mocks/blueprints/creatives'
import { FacebookFormatset as mockedFormatsetBlueprintFacebook } from '../../mocks/blueprints/formatsets'
import { PerformanceAdvertisingFormatset as mockedFormatsetBlueprintPerformanceAdvertising } from '../../mocks/blueprints/formatsets'
import { FormValue } from '../../interfaces/components/dynamic-form'
import { initialize as initializeDynamicForm } from '../../lib/dynamic-form/helpers'

const blueprintServiceMock: (DI: any) => IBlueprintService = (DI) => {
  const initFormatsetForm: InitializeFormatsetForm = async (_options) => {
    await delay(1000)

    // @ts-ignore
    const changeHandler: FormChangeHandler = async (blueprint, value) => {
      await delay(1000)

      return {
        value,
        blueprint: blueprint,
        validation: {
          validUntil: 'end',
          fields:
            Math.random() >= 0.4
              ? {}
              : {
                  fs_type: {
                    status: 'warning',
                    message: 'Check yoself',
                  },
                },
        },
      }
    }

    const blueprint =
      _options.type === 'performance_advertising'
        ? mockedFormatsetBlueprintPerformanceAdvertising
        : mockedFormatsetBlueprintFacebook

    return resultSuccess({
      value: initializeDynamicForm(blueprint),
      validation: formValidation(),
      guidelines: emptyFormGuidelines(),
      blueprint: blueprint,
      changeHandler,
    })
  }

  const initCreativeForm: InitializeCreativeForm = async (params) => {
    await delay(1000)

    const changeHandler: FormChangeHandler = async (value: FormValue) => {
      await delay(1000)

      return {
        value,
        blueprint: mockedCreativeBlueprint,
        validation: formValidation(),
      }
    }

    return resultSuccess({
      value: initializeDynamicForm(mockedCreativeBlueprint),
      validation: formValidation(),
      blueprint: mockedCreativeBlueprint,
      guidelines: emptyFormGuidelines(),
      changeHandler,
    })
  }

  const getFormatsetBlueprint = async () => {
    return mockedFormatsetBlueprintFacebook
  }

  const getCreativeGuidelines: GetCreativeGuidelines = async (id) => {
    return resultSuccess(emptyFormGuidelines())
  }

  return {
    initCreativeForm,
    initFormatsetForm,

    getCreativeGuidelines,
    getFormatsetBlueprint,
  }
}

export default blueprintServiceMock
